import { stickyNavOnScroll } from '../utils/stickyNavOnScroll';
import { enableScrollLock, disableScrollLock } from '../utils/scrollLock';
import { _removeLinkedListItem } from 'gsap/gsap-core';
import { onScroll } from '../utils/scroll';

export let nav;

export function toggleMenuOpen() {
    if (nav.classList.contains('nav--open')) {
        disableScrollLock();
        nav.classList.remove('nav--open');

        const activeSub = nav.querySelector('.nav__sub.js-active');

        if (activeSub) {
            activeSub.classList.remove('js-active');
        }

        if (window.pageYOffset > 50) {
            setTimeout(() => nav.classList.add('going-up'), 40);
        }

    } else {
        enableScrollLock();
        nav.classList.add('nav--open');
    }
}

export function setupNav(selector = '.nav', sticky = true) {
    nav = document.body.querySelector(selector);

    function clickSearchIcon(e) {
        if (document.body.classList.contains('js-search')) {
            document.body.classList.remove('js-search');
        } else {
            document.body.classList.add('js-search');
        }
    }

    function hideSearchForm() {
        document.body.classList.remove('js-search');
    }

    function clickLanguageSelect() {
        if (document.body.classList.contains('js-langauge-select')) {
            document.body.classList.remove('js-langauge-select');
        } else {
            document.body.classList.add('js-langauge-select');
        }
    }

    function clickNavLinkWithChildren(e) {
        e.preventDefault();

        const subNav = e.currentTarget.nextElementSibling;

        if (subNav) {
            subNav.classList.add('js-active');
        }
    }

    function clickNavBack(e) {
        const subNav = e.currentTarget.closest('.nav__sub');

        if (subNav) {
            subNav.classList.remove('js-active');
        }
    }

    function focusSubNavLink(e) {
        document.body.classList.add('js-nav-focus');
    }

    function blurSubNavLink(e) {
        if (!document.activeElement.closest('.nav__sub')) {
            document.body.classList.remove('js-nav-focus');
        }
    }

    if (nav) {
        const navBtn = nav.querySelector('.nav__btn');

        navBtn.addEventListener('click', toggleMenuOpen);

        if (sticky) {
            stickyNavOnScroll(nav, 'nav--sticky', 30, 'going-up');
        }

        const navSearchIcon = nav.querySelector('.nav__search .icon-search');
        const navSearchField = nav.querySelector('.nav__search__form #q');

        if (navSearchIcon && navSearchIcon) {
            navSearchIcon.addEventListener('click',clickSearchIcon);
            navSearchField.addEventListener('blur', hideSearchForm);
        }

        const navLanguageSelect = nav.querySelector('.nav__language-select .active');

        if (navLanguageSelect) {
            navLanguageSelect.addEventListener('click',clickLanguageSelect);
        }

        const primaryNav = nav.querySelector('.nav__primary');
        const navStyles = getComputedStyle(primaryNav);
        const navsWithChildren = nav.querySelectorAll('a.level-1.has-children');

        if (navStyles.opacity == 0) {
            navsWithChildren.forEach(link => {
                link.addEventListener('click', clickNavLinkWithChildren);
            });
        }

        const navBacks = nav.querySelectorAll('.nav__sub__back');

        Array.from(navBacks).forEach(navBack => {
            navBack.addEventListener('click',clickNavBack);
        });

        const navSubLinks = nav.querySelectorAll('.nav__sub a');

        Array.from(navSubLinks).forEach(link => {
            link.addEventListener('focus',focusSubNavLink);
            link.addEventListener('blur',blurSubNavLink);
        });
    }

    onScroll(() => {
        if (document.body.classList.contains('js-langauge-select')) {
            document.body.classList.remove('js-langauge-select');
        }
    });
}
